import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { IconButton, MenuItem, ListItemIcon, ListItemText } from "@material-ui/core";
import { MoreVert, Replay, CheckCircleOutline, PersonOutline } from "@material-ui/icons";
import { i18n } from "../../translate/i18n";
import { messengerText as text } from "../../translate/messenger";
import api from "../../services/api";
import TicketOptionsMenu from "../TicketOptionsMenu";
import ButtonWithSpinner from "../ButtonWithSpinner";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";

export default function TicketActionButtons({ ticket, onContact }) {
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);
  const { user } = useContext(AuthContext);
  const updateStatus = async (status, userId) => {
    setLoading(true);
    try {
      await api.put(`/tickets/${ticket.id}`, { status, userId: userId || null });
      setAnchorEl(null);
      history.push(status === "open" ? `/tickets/${ticket.id}` : "/tickets");
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  };
  const primaryAction = ticket.status === "open"
    ? ["closed", "resolve", CheckCircleOutline]
    : ["open", ticket.status === "pending" ? "accept" : "reopen", Replay];
  const [status, label, Icon] = primaryAction;
  return <div className="tw-flex tw-items-center tw-gap-1">
    <ButtonWithSpinner className="tw-hidden tw-rounded-full tw-border tw-border-solid tw-border-messenger-green tw-px-4 tw-normal-case tw-text-messenger-green sm:tw-inline-flex" loading={loading} startIcon={<Icon />} size="small" onClick={() => updateStatus(status, user.id)}>
      {i18n.t(`messagesList.header.buttons.${label}`)}
    </ButtonWithSpinner>
    <IconButton aria-label={text("actions")} onClick={event => setAnchorEl(event.currentTarget)}><MoreVert /></IconButton>
    <TicketOptionsMenu ticket={ticket} anchorEl={anchorEl} menuOpen={Boolean(anchorEl)} handleClose={() => setAnchorEl(null)} statusActions={[
      <MenuItem key="primary" disabled={loading} onClick={() => updateStatus(status, user.id)} className="tw-min-h-[48px]">
        <ListItemIcon><Icon /></ListItemIcon><ListItemText primary={i18n.t(`messagesList.header.buttons.${label}`)} />
      </MenuItem>,
      ticket.status === "open" && <MenuItem key="return" disabled={loading} onClick={() => updateStatus("pending", null)} className="tw-min-h-[48px]">
        <ListItemIcon><Replay /></ListItemIcon><ListItemText primary={i18n.t("messagesList.header.buttons.return")} />
      </MenuItem>,
      <MenuItem key="contact" onClick={() => { setAnchorEl(null); onContact(); }} className="tw-min-h-[48px]">
        <ListItemIcon><PersonOutline /></ListItemIcon><ListItemText primary={i18n.t("contactDrawer.header")} />
      </MenuItem>
    ]} />
  </div>;
}
